
import React,{ useEffect, useState,useRef, useContext } from 'react';
import { ReceiveQuestions, ReceiveQuestionsMultiDomain, ReceiveScore, SubmitAnswer } from '../../services/PyschometricQuestions';
import Webcam from "react-webcam";
import { SendVideo } from '../../services/PyschometricTest';
import Header from '../../components/Navigation/Header';
import sendAudioToOpenAIWhisper from '../../utils/transcribeAudio';
import Cookies from 'js-cookie';
import { useNavigate } from 'react-router-dom';
import clock from '../../Assets/clock.png';
import { userDetails } from '../../context/User';

function PyschometricQuestionSwipe(){
  
    const [questions,setQuestion]=useState([]);
    const [questionID,setQuestionID]=useState('');
    const [questionCategories,setQuestionCategory]=useState('');
    const [originalAnswer,setOriginalAnswer]=useState([]);

    const [candidateAnswer,setcandidateAnswer]=useState();

    const [score,setScore]=useState();

    const [index,setIndex]=useState(0)
    const webcamRef = useRef(null);

    const mediaRecorderRef = useRef(null);
    const [recording, setRecording] = useState(false);
    const [recordedChunks, setRecordedChunks] = useState([]);
    const [mute,setMute]=useState(true);
    // const [transcript,setTranscript]=useState('');
    const [flagging,setFlagged]=useState((Array.from({length:5},(_,index)=>index+1)));
    const navigate=useNavigate();
    const [editTranscribe,setEditTranscibe] = useState('');
    
    const [completedQuestions,setCompletedQuestions]=useState(0);

    const [testCompleted,setTestCompleted]=useState(false);
    const [updateTrigger, setUpdateTrigger] = useState(0);
    const [tags,setTags]=useState([]);
    const [loading, setLoading] = useState(true);

    const [totalQuestions, setTotalQuestions] = useState(0);

    const {user}=useContext(userDetails);

    const initialTime = 3 * 60; // 3 minutes in seconds
    const storedTime = localStorage.getItem("timerEnd");

    const calculateTimeLeft = () => {
      if (storedTime) {
        const now = Math.floor(Date.now() / 1000); // Get current time in seconds
        const timeLeft = storedTime - now;
        return timeLeft > 0 ? timeLeft : 0;
      }
      return initialTime;
    };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());
  
  const resetTimer = () => {
    const endTime = Math.floor(Date.now() / 1000) + initialTime;
    localStorage.setItem("timerEnd", endTime);
    setTimeLeft(initialTime);
  };

  useEffect(() => {
    if (timeLeft <= 0) {
      setTimeout(handleAnswerSubmit, 100); 
    };

    const timer = setInterval(() => {
      setTimeLeft((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          localStorage.removeItem("timerEnd");
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [timeLeft]);

  // Save end time in localStorage when timer starts
  useEffect(() => {
    if (!storedTime) {
      const endTime = Math.floor(Date.now() / 1000) + initialTime;
      localStorage.setItem("timerEnd", endTime);
    }
  }, []);

  // Convert seconds to MM:SS format
  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${minutes}:${secs < 10 ? "0" : ""}${secs}`;
  };

  
  const [currentQuestionIndex,setCurrentQuestionIndex]=useState();
const completedQuestionCheck = async () => {
  
 

      if (!user?.profile?.registeredPosition?.role || !user?.profile?.registeredPosition?.primaryDomain) {

          console.log('Profile data not loaded yet');
          return;
      }

      const domains=[];

      if (user?.profile?.registeredPosition?.primaryDomain) {
        domains.push(user.profile.registeredPosition.primaryDomain);
      }

      // Add preferred domains if they exist and are an array
      if (Array.isArray(user?.profile?.preferredDomains) && user.profile.preferredDomains.length > 0) {
        user.profile.preferredDomains.forEach(domain => domains.push(domain));
      }

     console.log('domains',user);  

     const roleName = user.profile?.registeredPosition?.role;

      if (!roleName) {
          console.error('Role name not found');
          return;
      }

    const experience= user.profile?.registeredPosition.experienceLevel
    if (!experience) {
          console.error('Experience not found');
          return;
      }
    // console.log(user.profile.preferredRole, user.profile.preferredDomains )
    const questions = await ReceiveQuestionsMultiDomain(roleName,domains,experience);
    

    let completedQuestions = questions?.data.length;
    let totalQuestions = questions?.total;
    const newCount = totalQuestions - completedQuestions;
    
    setCurrentQuestionIndex(newCount);
    setCompletedQuestions(prev => (prev !== newCount ? newCount : prev));
    setTotalQuestions(totalQuestions); // Keep total questions updated
    setUpdateTrigger(prev => prev + 1);
}
   

    const fetchQuestion = async () => {


      if (!user?.profile?.registeredPosition?.role || !user?.profile?.registeredPosition?.primaryDomain) {

          console.log('Profile data not loaded yet');
          return;
      }

      const domains=[];

      if (user?.profile?.registeredPosition?.primaryDomain) {
        domains.push(user.profile.registeredPosition.primaryDomain);
      }

      // Add preferred domains if they exist and are an array
      if (Array.isArray(user?.profile?.preferredDomains) && user.profile.preferredDomains.length > 0) {
        user.profile.preferredDomains.forEach(domain => domains.push(domain));
      }

     console.log('domains',user);  

     const roleName = user.profile?.registeredPosition?.role;

      if (!roleName) {
          console.error('Role name not found');
          return;
      }

    const experience= user.profile?.registeredPosition.experienceLevel
    if (!experience) {
          console.error('Experience not found');
          return;
      }

    setLoading(true);
    // console.log(user.profile.preferredRole, user.profile.preferredDomains )
    const questions = await ReceiveQuestionsMultiDomain(roleName,domains,experience);

    setLoading(false);
    const question = []
    const originalAnswer = []
    const categories = []
    const questionsIDs = []
    const tags = []
    
    if (questions && questions.success) {
        questions?.data.forEach(e => {
            question.push(e.question);
            questionsIDs.push(e.id);
            categories.push('psychometric');
            tags.push(e.area);
            originalAnswer.push(e.answer);
        });
        
        setTestCompleted(questions.completed);
        setQuestionID(questionsIDs);
        setQuestionCategory(categories);
        setOriginalAnswer(originalAnswer);
        setQuestion(question);
        setTags(tags);
        
        // Set total questions from the API response
        setTotalQuestions(questions?.total || question.length);
        setFlagged(Array.from({length: questions?.total || question.length}, (_, index) => index + 1));
        setIndex(0);
        return;
    }
}
      useEffect(()=>{fetchQuestion()},[]);
      // useEffect(()=>{completedQuestionCheck()},[updateTrigger]);
  
    const micHandler=()=>{
      setMute(!mute); 
    };

  const startRecording = () => {

    setRecording(true);
    setRecordedChunks([]); 
    // const colorChange=document.querySelector('.mic');
    
    // if(!colorChange.classList.contains('colorchange'))
    //     colorChange.classList.add('colorchange');

    // console.log(colorChange);

    navigator.mediaDevices.getUserMedia({ audio: mute, video: false })
      .then((stream) => {
        const mediaRecorder = new MediaRecorder(stream, {
          mimeType: "audio/webm", 
        });
  
        mediaRecorderRef.current = mediaRecorder;
  
        mediaRecorder.ondataavailable = (event) => {
          if (event.data && event.data.size > 0) {
            setRecordedChunks((prev) => prev.concat(event.data));
            sendAudioToOpenAIWhisper(event.data).then(answer=>{ answer && setEditTranscibe(prev=>prev.concat(answer));})
            .catch(error=>console.log(error))
          }
        };

        mediaRecorder.start();
      })
      .catch((error) => {
        console.error("Error accessing audio device:", error);
      });
  };

    const stopRecording = () => {
      setRecording(false);
      if(mediaRecorderRef.current!==null)
        {
          mediaRecorderRef.current.stop();
         return;
        }
        else
        {
          console.log('There is no camera attach');
        }

    
      const colorChange=document.querySelector('.mic');
    
    if(colorChange.classList.contains('colorchange'))
        colorChange.classList.remove('colorchange');
    console.log('change',colorChange);
    };

  
    const downloadRecording = async () => {
      const blob = new Blob(recordedChunks, { type: "audio/webm" });
      SendVideoBackend(blob)
      setRecordedChunks([]);
    };
    React.useEffect(() => {
      if (!recording && recordedChunks.length > 0) {
        // console.log("size2",recordedChunks[0])
        downloadRecording(); 
      }
    }, [recordedChunks]);

  
    useEffect(()=>setcandidateAnswer(""),[index]);
    
  const getCurrentQuestionNumber = () => {
      // Use currentQuestionIndex if available, otherwise use index + 1
      return currentQuestionIndex !== undefined ? currentQuestionIndex + 1 : index + 1;
  }

    async function SendVideoBackend(video){
      // console.log("videosize",video)
      const dataReceived=await SendVideo(video);
      if(dataReceived)
      {
        if(dataReceived.transcription)
         { HandlingScores( dataReceived.transcription);
          setcandidateAnswer(dataReceived.transcription);
        return;
         }
      }
      console.log("Issue in receiving transcription");
    }

    async function HandlingScores(candidateAnswer)
    {
      const dataReceived=await ReceiveScore({question:questions[index],originalAnswer:originalAnswer[index],candidateAnswer:candidateAnswer});
      if(dataReceived)
      {
        // console.log(dataReceived,"candidatae",candidateAnswer);
        setScore(dataReceived.score);
        return;
      }
      console.log("Issue in receiving scores");
    }
    const handleSubmitAnswer=async (answer,completed)=>{
      if(questionID)
      {
        const response=await SubmitAnswer({
          questionID:questionID[index],
          originalAnswer:originalAnswer[index],
          answer:answer || "not given",
          completed:completed,score:score || "0",
          userID:Cookies.get('id'),
          tag:tags[index],
          category:questionCategories[index]});
        // console.log('submit question',response);
      }
       
    }
  const handleAnswerSubmit = async (e) => {
    if (!questions.length) return;
    
    resetTimer();
    
    // Use a more reliable check for the last question
    const isLastQuestion = (index >= questions.length - 1) || (index >= totalQuestions - 1);
    
    if (isLastQuestion) {
        await HandlingScores(editTranscribe);
        await handleSubmitAnswer(editTranscribe, true);
        navigateToScore();
        return;
    }
    
    await HandlingScores(editTranscribe);
    await handleSubmitAnswer(editTranscribe, false);
    
    setIndex(prev => prev + 1);
    setEditTranscibe('');
    setScore('');
}

    const navigateToScore=()=>{
      if(index>=questions?.length-1)
        {
          sessionStorage.setItem('pyschometricTestStatus',"COMPLETED")
          navigate('score')
          return;
        }
    }

    useEffect(() => { 
         console.log('index',index,'question',questions.length);
    },[index]);


    useEffect(() => {
      const disableRightClick = (e) => e.preventDefault();
      document.addEventListener("contextmenu", disableRightClick);
    
      return () => {
        document.removeEventListener("contextmenu", disableRightClick);
      };
    }, []);
    useEffect(() => {
      const disableCopyPaste = (e) => e.preventDefault();
    
      document.addEventListener("copy", disableCopyPaste);
      document.addEventListener("paste", disableCopyPaste);
      document.addEventListener("cut", disableCopyPaste);
    
      return () => {
        document.removeEventListener("copy", disableCopyPaste);
        document.removeEventListener("paste", disableCopyPaste);
        document.removeEventListener("cut", disableCopyPaste);
      };
    }, []);

    {loading ? (
    <div>Loading questions...</div>
) : (
    <div className="question-title">
        <h2>Q{getCurrentQuestionNumber()}. {questions[index] || 'Loading question...'}</h2>
    </div>
)}
    return(
        <>
        <Header disabledNavigation={true}/>
         <div className='pyschometrictestcontainer'>
             <section className='pyschometrictext'>
               <div className='topfield'>
                    <div className='topsubfield'>
                    <h2>Pyschometric Test</h2>
                    <h4><span>Home</span><span> &nbsp; &gt; Pyschometric Test</span><span style={{color:'#8A090D'}}> &nbsp; &gt; Quiz</span></h4>
                </div>
                 <div className='timer' role='timer' aria-live='polite' aria-atomic='true'>
                                      <div>
                                          <img src={clock} alt='Timer icon' />
                                          <h2>{formatTime(timeLeft)}</h2>
                                      </div>
                                  </div>
                </div>
             </section>
             <section className='questionswipecontainer'>
             <div className="question-title"><h2>Q{getCurrentQuestionNumber()}. {questions[index] || 'Loading question...'}</h2></div>       
                    <div className='questionswipesubcontainer'>
              <div className='camerapart'>
                <div>
                <Webcam
                audio={false}
                ref={webcamRef}
                screenshotFormat="image/jpeg"
                className='webcam'
                videoConstraints={{
                               facingMode: "user"
                }}
                audioConstraints={{
                  echoCancellation: true,
                  noiseSuppression: true,
                  sampleRate: 44100,
                  channelCount: 1,
                }}
            />
            </div>
            </div>
            <div className='answerbox'>
            <h4>Your Answer:</h4>
             <textarea type='text' onChange={(e)=>{setEditTranscibe(e.target.value);setTimeout(()=>{HandlingScores(e.target.value)},1000)}} value={editTranscribe}/>
            </div>
            <aside className='flaggedquestions'>
             <div>
                 <h3>Questions</h3>
                    <nav className='flagged'>
                      {
                     flagging.map((element, index) => {
                    const totalCount = flagging.length;
                    
                    // Size decreases as count increases from the start
                    const baseSize = 50;
                    const minSize = 25;
                    const size = Math.max(minSize, baseSize - (totalCount - 1) * 1.5);
                    
                    const baseFontSize = 20;
                    const minFontSize = 10;
                    const fontSize = Math.max(minFontSize, baseFontSize - (totalCount - 1) * 0.8);
                    
                    return (
                      <button 
                        key={index} 
                        className={index < completedQuestions ? "answered" : "notanswered"}
                        style={{
                          width: `${size}px`,
                          height: `${size}px`,
                          fontSize: `${fontSize}px`,
                          minWidth: `${minSize}px`, // Ensures button doesn't get too small
                          minHeight: `${minSize}px`
                        }}
                      >
                        {element}
                      </button>
                    );
                  })
                      }
                  </nav>
              </div>
            </aside>
            </div>
              <div className='camerainterface'>
              {/* {
              mute?(
                <img src={micImg} width='50' height='50' alt='mic' className='mic' onClick={()=>micHandler()} />):
                (<img src={muteImg} width='50' height='50' alt='mic' className='mic' onClick={()=>micHandler()}/>)       
              } */}
              <div style={{width:"100%",marginTop:"20px"}}>
                  {recording ? (
                    <button onClick={stopRecording} style={{borderRadius:"0px",backgroundColor:"#8A090D"}}>STOP</button>
                  ) : (
                    <button onMouseDown={startRecording} onMouseUp={stopRecording} style={{borderRadius:"0px",backgroundColor:"#8A090D"}}>RECORD</button>
                  )}
              </div>
              {/* <h3>Score:{score?score:"No score"}</h3> */}
              </div>
             </section>
             
          </div>
           <footer className='bottombar'>
            <div className='proceedbtns'>
                <button 
                    type='button'
                    onClick={(e)=>{handleAnswerSubmit(e);}}
                >
          {(index >= questions?.length - 1) || (index >= totalQuestions - 1) ? 'SUBMIT' : 'NEXT'}

                </button>
            </div>
        </footer>
        </>);
}

export default PyschometricQuestionSwipe;